'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('SsoExistingCtrl', SsoExistingCtrl);

  SsoExistingCtrl.$inject = ['onboardingRouter', 'authenticationSvc', 'providerSvc', 'loadingScreenSvc', 'organization'];

  function SsoExistingCtrl(onboardingRouter, authenticationSvc, providerSvc, loadingScreenSvc, organization) {
    /*jshint validthis: true */
    var vm = this;
    var provider = {};
    vm.ssoAuthView = authenticationSvc.getCurrentSsoInfo();
    vm.organizationName = vm.cobrandingText = organization.name;
    vm.submit = _submit;

    loadingScreenSvc.createLoadingScreen(organization.name, function () {}, true);

    _init();

    function _init() {
      // Catch error from resolved organization
      if (organization.errorCode || !vm.ssoAuthView || !vm.ssoAuthView.attributesView) {
        onboardingRouter.navigateSsoError({
          contact: true
        });
        return;
      }

      provider = {
        organization: organization.shortName,
        accessCode: vm.ssoAuthView.attributesView.accessCode
      };

      providerSvc.setProvider(provider).then(function () {
        providerSvc.getHeader().then(function (data) {
          var contentItem;
          if (data && data.content) {
            contentItem = data.content.filter(function (headerContent) {
              return headerContent.target === 'image';
            })[0];
            if (contentItem) {
              vm.cobranding = contentItem.replacement;
            }
          }
        });
      });
    }

    function _submit() {
      authenticationSvc.submitEmailVerificationRequest(vm.ssoAuthView).then(function () {
        vm.showSuccess = true;
      });
    }
  }
})();